import React from 'react';
import { useInView } from 'react-intersection-observer';
import MobileRentalActiveMarker from './MobileRentalActiveMarker';
import MobileListingActiveMarker from './MobileListingActiveMarker';
import MobileEventActiveMarker from './MobileEventActiveMarker';

export default function MobileActiveMarker({
  item,
  userData,
  itemType,
  setHoveredItem,
}) {
  const [ref, inView] = useInView({
    threshold: 0.75,
  });

  if (inView) {
    setHoveredItem(item);
  }

  return (
    <div ref={ref} className="mobile-active-marker">
      {itemType === 'rentals' && (
        <MobileRentalActiveMarker item={item} userData={userData} />
      )}
      {itemType === 'listings' && (
        <MobileListingActiveMarker item={item} userData={userData} />
      )}
      {itemType === 'events' && (
        <MobileEventActiveMarker item={item} userData={userData} />
      )}
    </div>
  );
}
